/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UnpairRfidPathParameters } from 'api/actions/unpair-rfid/unpair-rfid-path-parameters';
import { UnpairRfidResponse } from 'api/actions/unpair-rfid/unpair-rfid-response';

type UnpairRfidQueryParameters = Record<string, any>;

/**
 * The path of the UnpairRfid action.
 */
export const unpairRfidActionPath = new SweetPath<keyof UnpairRfidPathParameters>('/rfid/unpair/{id}', {
  path: '{param}',
});

/**
 * Creates a contextualized UnpairRfid actions.
 */
export default function createUnpairRfidAction(axios: AxiosInstance) {
  return function unpairRfidAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: UnpairRfidPathParameters;
    query?: UnpairRfidQueryParameters;
  }) {
    const path = unpairRfidActionPath.insert(parameters);

    return axios.post<UnpairRfidResponse, UnpairRfidResponse>(path, { params: query, headers });
  };
}
